export const ANDROID = 'android'
export const IOS = 'ios'
export const WEB = 'web'
